import logo from "Assets/images/logo.png";

const KhanReportLogo = () => {
  return (
    <>
      <img
        src={logo}
        alt=""
        className="img-fluid object-fit-contain"
        style={{ height: 70 }}
      />
      <p className="m-0 fw-sbold">Supporting development through life</p>
      <p className="m-0 fw-sbold">
        w:{" "}
        <a className="text-primary" href="/client/discharge-summary-report">
          khancomunicationservices.com
        </a>
      </p>
      <p className="m-0 fw-sbold">
        Instagram:{" "}
        <a className="text-primary" href="/client/discharge-summary-report">
          @khanCommServices
        </a>
      </p>
    </>
  )
}

export default KhanReportLogo;